import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const fetchUserLeagueSubmissionsCount = async (
  userId,
  leagueId,
  getAccessTokenSilently,
) => {
  const token = await getAccessTokenSilently();
  const apiUrl = process.env.REACT_APP_API_URL;

  const { data } = await axios.get(
    `${apiUrl}/api/lineup/user/${userId}/league/${leagueId}/count`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return data;
};

export const useUserLeagueSubmissionsCount = (userId, leagueId) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery(
    ["userLeagueSubmissionsCount", userId, leagueId],
    () =>
      fetchUserLeagueSubmissionsCount(userId, leagueId, getAccessTokenSilently),
    {
      enabled: !!userId && !!leagueId, // The query will not execute until both userId and leagueId are available
    },
  );
};
